const initialState = {
  coachingListLoading: false,
  coachingList: null,
  coachingListError: null,
  coachingCourseListLoading: false,
  coachingCourseList: null,
  coachingCourseListError: null,
  coachingExamsLoading: false,
  coachingExams: null,
  coachingExamsError: null,
  coachingSubjectsLoading: false,
  coachingSubjects: null,
  coachingSubjectsError: null,
  coachingCourseDropdownListLoading: false,
  coachingCourseDropdownList: null,
  coachingCourseDropdownListError: null,
  courseLoading: false,
  course: null,
  courseError: null,
  coaching: null,
  coachingMediaDropdownLoading: false,
  coachingMediaDropdown: null,
  coachingMediaDropdownError: null,
  coachingNameLoading: false,
  coachingName: null,
  coachingNameError: null,
  coachingToppersLoading: false,
  coachingToppers: null,
  coachingToppersError: null,
  post_cms_coaching_overview_success: null,
  coachingInstituteLoading: false,
  coachingInstitute: null,
  coachingInstituteError: null,
  coachingDistrictLoading: false,
  coachingDistrict: null,
  coachingDistrictError: null,
  uploadedMediaImage: null,
  uploadedMediaImageError: null,
  coursePublishLoading: false,
  coursePublish: null,
  coursePublishError: null,
  coachingPublishLoading: false,
  coachingPublish: null,
  coachingPublishError: null,
  Delete_cms_coaching_course_success: null,
  post_cms_coaching_course_failure: null,
  Delete_cms_coaching_course_loading: false,
  patchCmsCoachingOverviewData: null,
  patchCmsCoachingOverviewError: null,
  patchCmsCoachingOverviewLoading: false,
  postCoachingInstituteLoading: false,
  postCmsCoachingTopperLoading: false,
  post_cms_coaching_topper_success: null,
  post_cms_coaching_course_loading: false
};

const coachingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CMS_COACHING_LIST_REQUEST":
      return {
        ...state,
        coachingListLoading: true,
      };
    case "GET_CMS_COACHING_LIST_SUCCESS":
      return {
        ...state,
        coachingListLoading: false,
        coachingList: action.payload,
      };
    case "GET_CMS_COACING_LIST_FAILURE":
      return {
        ...state,
        coachingListLoading: false,
        coachingListError: action.payload,
      };
    case "GET_CMS_COACHING_COURSES_LIST_REQUEST":
      return {
        ...state,
        coachingCourseListLoading: true,
      };
    case "GET_CMS_COACHING_COURSES_LIST_SUCCESS":
      return {
        ...state,
        coachingCourseListLoading: false,
        coachingCourseList: action.payload,
      };
    case "GET_CMS_COACHING_COURSES_LIST_FAILURE":
      return {
        ...state,
        coachingCourseListLoading: false,
        coachingCourseListError: action.payload,
      };
    case "GET_CMS_COACHING_EXAMS_REQUEST":
      return {
        ...state,
        coachingExamsLoading: true,
      };
    case "GET_CMS_COACHING_EXAMS_SUCCESS":
      return {
        ...state,
        coachingExamsLoading: false,
        coachingExams: action.payload,
      };
    case "GET_CMS_COACHING_EXAMS_FAILURE":
      return {
        ...state,
        coachingExamsLoading: false,
        coachingExamsError: action.payload,
      };
    case "GET_CMS_COACHING_SUBJECTS_REQUEST":
      return {
        ...state,
        coachingSubjectsLoading: true,
      };
    case "GET_CMS_COACHING_SUBJECTS_SUCCESS":
      return {
        ...state,
        coachingSubjectsLoading: false,
        coachingSubjects: action.payload,
      };
    case "GET_CMS_COACHING_SUBJECTS_FAILURE":
      return {
        ...state,
        coachingSubjectsLoading: false,
        coachingSubjectsError: action.payload,
      };
    case "GET_CMS_COACHING_COURSE_DROPDOWN_LIST_REQUEST":
      return {
        ...state,
        coachingCourseDropdownListLoading: true,
      };
    case "GET_CMS_COACHING_COURSE_DROPDOWN_LIST_SUCCESS":
      return {
        ...state,
        coachingCourseDropdownListLoading: false,
        coachingCourseDropdownList: action.payload,
      };
    case "GET_CMS_COACHING_COURSE_DROPDOWN_LIST_FAILURE":
      return {
        ...state,
        coachingCourseDropdownListLoading: false,
        coachingCourseDropdownListError: action.payload,
      };
    case "GET_CMS_COACHING_COURSE_REQUEST":
      return {
        ...state,
        courseLoading: true,
      };
    case "GET_CMS_COACHING_COURSE_SUCCESS":
      return {
        ...state,
        courseLoading: false,
        course: action.payload,
      };
    case "GET_CMS_COACHING_COURSE_FAILURE":
      return {
        ...state,
        courseLoading: false,
        courseError: action.payload,
      };
    case "CLEAR_COACHING_COURSE":
      return {
        ...state,
        course: null,
        courseError: null,
      };
    case "POST_CMS_COACHING_OVERVIEW_LOADING":
      return {
        ...state,
        post_cms_coaching_overview_success: null,
        post_cms_coaching_overview_failure: null,
        message: null,
      };
    case "POST_CMS_COACHING_OVERVIEW_SUCCESS":
      return {
        ...state,
        post_cms_coaching_overview_success: action.payload,
        message: "Overview Details Added Successfully",
      };
    case "POST_CMS_COACHING_OVERVIEW_FAILURE":
      return {
        ...state,
        post_cms_coaching_overview_failure: action.payload,
        message: "Failure in Adding Overview Details",
      };
    case "CLEAR_POST_CMS_COACHING_OVERVIEW":
      return {
        ...state,
        post_cms_coaching_overview_success: null,
        post_cms_coaching_overview_failure: null,
        message: null,
      };
    case "GET_CMS_COACHING_REQUEST":
      return {
        ...state,
        coachingLoading: true,
      };
    case "GET_CMS_COACHING_SUCCESS":
      return {
        ...state,
        coachingLoading: false,
        coaching: action.payload,
      };
    case "GET_CMS_COACING_FAILURE":
      return {
        ...state,
        coachingLoading: false,
        coachingError: action.payload,
      };
    case "CLEAR_COACHING":
      return {
        ...state,
        coaching: null,
      };
    case "GET_CMS_COACHING_LOCATION_REQUEST":
      return {
        ...state,
        coachingLocationLoading: true,
      };
    case "GET_CMS_COACHING_LOCATION_SUCCESS":
      return {
        ...state,
        coachingLocationLoading: false,
        coachingLocation: action.payload,
      };
    case "GET_CMS_COACHING_LOCATION_FAILURE":
      return {
        ...state,
        coachingLocationLoading: false,
        coachingLocationError: action.payload,
      };
    case "PATCH_CMS_COACHING_OVERVIEW_LOADING":
      return {
        ...state,
        patchCmsCoachingOverviewData: null,
        patchCmsCoachingOverviewError: null,
        patchCmsCoachingOverviewLoading: true,
      };
    case "PATCH_CMS_COACHING_OVERVIEW_SUCCESS":
      return {
        ...state,
        patchCmsCoachingOverviewData: action.payload,
        patchCmsCoachingOverviewLoading: false,
        message: "Overview Details Edited Successfully",
      };
    case "PATCH_CMS_COACHING_OVERVIEW_FAILURE":
      return {
        ...state,
        patchCmsCoachingOverviewError: action.payload,
        patchCmsCoachingOverviewLoading: false,
        message: "Failure in Editing Overview Details",
      };
    case "CLEAR_PATCH_CMS_COACHING_OVERVIEW":
      return {
        ...state,
        patchCmsCoachingOverviewData: null,
        patchCmsCoachingOverviewError: null,
        message: null,
      };
    case "GET_CMS_COACHING_MEDIA_DROPDOWN_REQUEST":
      return {
        ...state,
        coachingMediaDropdownLoading: true,
      };
    case "GET_CMS_COACHING_MEDIA_DROPDOWN_SUCCESS":
      return {
        ...state,
        coachingMediaDropdownLoading: false,
        coachingMediaDropdown: action.payload,
      };
    case "GET_CMS_COACHING_MEDIA_DROPDOWN_FAILURE":
      return {
        ...state,
        coachingMediaDropdownLoading: false,
        coachingMediaDropdownError: action.payload,
      };
    case "GET_CMS_COACHING_MEDIA_REQUEST":
      return {
        ...state,
        coachingMediaLoading: true,
      };
    case "GET_CMS_COACHING_MEDIA_SUCCESS":
      return {
        ...state,
        coachingMediaLoading: false,
        coachingMedia: action.payload,
      };
    case "GET_CMS_COACING_MEDIA_FAILURE":
      return {
        ...state,
        coachingMediaLoading: false,
        coachingMediaError: action.payload,
      };
    case "CLEAR_COACHING_MEDIA":
      return {
        ...state,
        coachingMedia: null,
      };
    case "POST_CMS_COACHING_TOPPER_LOADING":
      return {
        ...state,
        postCmsCoachingTopperLoading: true,
        post_cms_coaching_topper_success: null,
      };
    case "POST_CMS_COACHING_TOPPER_SUCCESS":
      return {
        ...state,
        postCmsCoachingTopperLoading: false,
        post_cms_coaching_topper_success: action.payload,
        message: "Topper Details Added Successfully",
      };
    case "POST_CMS_COACHING_TOPPER_FAILURE":
      return {
        ...state,
        postCmsCoachingTopperLoading: false,
        post_cms_coaching_topper_failure: action.payload,
        message: "Failure in Adding Topper Details",
      };
    case "CLEAR_POST_CMS_COACHING_TOPPER":
      return {
        ...state,
        post_cms_coaching_topper_success: null,
        post_cms_coaching_topper_failure: null,
        message: null,
      };
    case "PATCH_CMS_COACHING_TOPPER_SUCCESS":
      return {
        ...state,
        patchCmsCoachingTopper: action.payload,
        message: "Topper Details Edited Successfully",
      };
    case "PATCH_CMS_COACHING_TOPPER_FAILURE":
      return {
        ...state,
        patchCmsCoachingTopperError: action.payload,
        message: "Failure in Editing Topper Details",
      };
    case "CLEAR_PATCH_CMS_COACHING_TOPPER":
      return {
        ...state,
        patchCmsCoachingTopper: null,
        patchCmsCoachingTopperError: null,
        message: null,
      };
    case "GET_CMS_COACHING_MEDIA_REQUEST":
      return {
        ...state,
        coachingMediaLoading: true,
      };
    case "GET_CMS_COACHING_MEDIA_SUCCESS":
      return {
        ...state,
        coachingMediaLoading: false,
        coachingMedia: action.payload,
      };
    case "GET_CMS_COACING_MEDIA_FAILURE":
      return {
        ...state,
        coachingMediaLoading: false,
        coachingMediaError: action.payload,
      };
    case "CLEAR_COACHING_MEDIA":
      return {
        ...state,
        coachingMedia: null,
      };
    case "UPDATE_CMS_COACHING_MEDIA_SUCCESS":
      return {
        ...state,
        update_cms_coaching_media_success: action.payload,
        message: "Media Details Added Successfully",
      };
    case "UPDATE_CMS_COACHING_MEDIA_FAILURE":
      return {
        ...state,
        update_cms_coaching_media_failure: action.payload,
        message: "Failure in Adding Media Details",
      };
    case "CLEAR_UPDATE_CMS_COACHING_MEDIA":
      return {
        ...state,
        update_cms_coaching_media_success: null,
        update_cms_coaching_media_failure: null,
        message: null,
      };
    case "UPDATE_CMS_COACHING_COURSE_LOADING":
      return {
        ...state,
        update_cms_coaching_course_success: null,
        update_cms_coaching_course_failure: null,
        message: null,
      };
    case "UPDATE_CMS_COACHING_COURSE_SUCCESS":
      return {
        ...state,
        update_cms_coaching_course_success: action.payload,
        message: "Course Details Edited Successfully",
      };
    case "UPDATE_CMS_COACHING_COURSE_FAILURE":
      return {
        ...state,
        update_cms_coaching_course_failure: action.payload,
        message: "Failure in Editing Course Details",
      };
    case "CLEAR_UPDATE_CMS_COACHING_COURSE":
      return {
        ...state,
        update_cms_coaching_course_success: null,
        update_cms_coaching_course_failure: null,
        message: null,
      };
    case "GET_CMS_COACHING_NAME_REQUEST":
      return {
        ...state,
        coachingNameLoading: true,
      };
    case "GET_CMS_COACHING_NAME_SUCCESS":
      return {
        ...state,
        coachingNameLoading: false,
        coachingName: action.payload,
      };
    case "GET_CMS_COACHING_NAME_FAILURE":
      return {
        ...state,
        coachingNameLoading: false,
        coachingNameError: action.payload,
      };
    case "POST_CMS_COACHING_COURSE_LOADING":
      return {
        ...state,
        post_cms_coaching_course_loading: true,
        post_cms_coaching_course_success: null,
        post_cms_coaching_course_failure: null,
        message: null,
      };
    case "POST_CMS_COACHING_COURSE_SUCCESS":
      return {
        ...state,
        post_cms_coaching_course_success: action.payload,
        post_cms_coaching_course_loading: false,
        message: "Course Details Added Successfully",
      };
    case "POST_CMS_COACHING_COURSE_FAILURE":
      return {
        ...state,
        post_cms_coaching_course_failure: action.payload,
        post_cms_coaching_course_loading: false,
        message: "Failure in Adding Course Details",
      };
    case "DELETE_CMS_COACHING_COURSE_LOADING":
      return {
        ...state,
        Delete_cms_coaching_course_success: null,
        delete_cms_coaching_course_failure: null,
        Delete_cms_coaching_course_loading: true
      };
    case "DELETE_CMS_COACHING_COURSE_SUCCESS":
      return {
        ...state,
        Delete_cms_coaching_course_success: action.payload,
        message: "Course Details Deleted Successfully",
        Delete_cms_coaching_course_loading: false
      };
    case "DELETE_CMS_COACHING_COURSE_FAILURE":
      return {
        ...state,
        delete_cms_coaching_course_failure: action.payload,
        message: "Failure in Deleted Course Details",
        Delete_cms_coaching_course_loading: false
      };
    case "CLEAR_DELETE_CMS_COACHING_COURSE":
      return {
        ...state,
        Delete_cms_coaching_course_success: null,
        delete_cms_coaching_course_failure: null,
      };
    case "CLEAR_POST_CMS_COACHING_COURSE":
      return {
        ...state,
        post_cms_coaching_course_success: null,
        post_cms_coaching_course_failure: null,
        message: null,
      };
    case "GET_CMS_COACHING_TOPPERS_REQUEST":
      return {
        ...state,
        coachingToppersLoading: true,
        coachingToppers: null,
        coachingToppersError: null,
      };
    case "GET_CMS_COACHING_TOPPERS_SUCCESS":
      return {
        ...state,
        coachingToppersLoading: false,
        coachingToppers: action.payload,
      };
    case "GET_CMS_COACING_TOPPERS_FAILURE":
      return {
        ...state,
        coachingToppersLoading: false,
        coachingToppersError: action.payload,
      };
    case "GET_CMS_COACHING_INSTITUTE_REQUEST":
      return {
        ...state,
        coachingInstituteLoading: true,
        coachingInstitute: null,
        coachingInstituteError: null,
      };
    case "GET_CMS_COACHING_INSTITUTE_SUCCESS":
      return {
        ...state,
        coachingInstituteLoading: false,
        coachingInstitute: action.payload,
      };
    case "GET_CMS_COACING_INSTITUTE_FAILURE":
      return {
        ...state,
        coachingInstituteLoading: false,
        coachingInstituteError: action.payload,
      };
    case "POST_CMS_COACHING_INSTITUTE_LOADING":
      return {
        ...state,
        postCoachingInstituteLoading: true,
      };
    case "POST_CMS_COACHING_INSTITUTE_SUCCESS":
      return {
        ...state,
        postCoachingInstituteLoading: false,
        post_cms_coaching_institute_success: action.payload,
        message: "Institute Details Added Successfully",
      };
    case "POST_CMS_COACHING_INSTITUTE_FAILURE":
      return {
        ...state,
        postCoachingInstituteLoading: false,
        post_cms_coaching_institute_failure: action.payload,
        message: "Failure in Adding Institute Details",
      };
    case "CLEAR_POST_CMS_COACHING_INSTITUTE":
      return {
        ...state,
        post_cms_coaching_institute_success: null,
        post_cms_coaching_institute_failure: null,
        message: null,
      };
    case "PATCH_CMS_COACHING_INSTITUTE_SUCCESS":
      return {
        ...state,
        patchCmsCoachingInstitute: action.payload,
        message: "Institute Details Edited Successfully",
      };
    case "PATCH_CMS_COACHING_INSTITUTE_FAILURE":
      return {
        ...state,
        patchCmsCoachingInstituteError: action.payload,
        message: "Failure in Editing Institute Details",
      };
    case "CLEAR_PATCH_CMS_COACHING_INSTITUTE":
      return {
        ...state,
        patchCmsCoachingInstitute: null,
        patchCmsCoachingInstituteError: null,
        message: null,
      };
    case "GET_COACHING_DISTRICT_REQUEST":
      return {
        ...state,
        coachingDistrictLoading: true,
      };
    case "GET_COACHING_DISTRICT_SUCCESS":
      return {
        ...state,
        coachingDistrictLoading: false,
        coachingDistrict: action.payload,
      };
    case "GET_COACHING_DISTRICT_FAILURE":
      return {
        ...state,
        coachingDistrictLoading: false,
        coachingDistrictError: action.payload,
      };
    case "DELETE_COACHING_OTHER_MEDIA_SUCCESS":
      return {
        ...state,
        deleteCoachingOtherMedia: action.payload,
      };
    case "DELETE_COACHING_OTHER_MEDIA_FAILURE":
      return {
        ...state,
        deleteCoachingOtherMediaError: action.payload,
      };
    case "POST_MEIDA_IMAGE_SUCCESS":
      return {
        ...state,
        uploadedMediaImage: action.payload,
      };
    case "POST_MEIDA_IMAGE_FAILURE":
      return {
        ...state,
        uploadedMediaImageError: action.payload,
      };
    case "POST_COURSE_PUBLISH_LOADING":
      return {
        ...state,
        coursePublishLoading: true,
      };
    case "POST_COURSE_PUBLISH_SUCCESS":
      return {
        ...state,
        coursePublishLoading: false,
        coursePublish: action.payload,
      };
    case "POST_COURSE_PUBLISH_FAILURE":
      return {
        ...state,
        coursePublishLoading: false,
        coursePublishError: action.payload,
      };
    case "CLEAR_COURSE_PUBLISH":
      return {
        ...state,
        coursePublishError: null,
        coursePublish: null,
      };
    case "POST_COACHING_PUBLISH_LOADING":
      return {
        ...state,
        coachingPublishLoading: true,
      };
    case "POST_COACHING_PUBLISH_SUCCESS":
      return {
        ...state,
        coachingPublishLoading: false,
        coachingPublish: action.payload,
      }
    case "POST_COACHING_PUBLISH_FAILURE":
      return {
        ...state,
        coachingPublishLoading: false,
        coachingPublishError: action.payload,
      };
    case "CLEAR_COACHING_PUBLISH":
      return {
        ...state,
        coachingPublishError: null,
        coachingPublish: null,
      }
    default:
      return state;
  }
};
export default coachingReducer;
